"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uuid = function () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c, r) {
    return (
      // tslint:disable-next-line
      ('x' === c ? r = Math.random() * 16 | 0 : r & 0x3 | 0x8).toString(16)
    );
  });
};
exports.moveToNewTarget = function (newTarget) {
  if (newTarget.current) {
    newTarget.current.focus();
    newTarget.current.select();
  }
};
exports.updateFocus = function (target) {
  setTimeout(function () {
    if (target.current) {
      target.current.focus();
    }
  }, 10);
};
exports.defaultOnFocus = function (event) {
  event.target.select();
};
exports.fillEmptyArray = function (size) {
  return Array(size).fill('');
};